// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { StartSignupAuthSignupEmailStartPostMutationRequest, StartSignupAuthSignupEmailStartPostMutationResponse, StartSignupAuthSignupEmailStartPost409, StartSignupAuthSignupEmailStartPost422, StartSignupAuthSignupEmailStartPost429 } from "../models/emailAuthController/StartSignupAuthSignupEmailStartPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getStartSignupAuthSignupEmailStartPostUrl() {
  const res = { method: 'POST', url: `/auth/signup/email/start` as const }
  return res
}

/**
 * @description Start email signup flow.
 * Sends verification code to provided email address.
 * Returns signup token for subsequent requests.
 * @summary Start Signup
 * {@link /auth/signup/email/start}
 */
export async function startSignupAuthSignupEmailStartPost(data: StartSignupAuthSignupEmailStartPostMutationRequest, config: Partial<RequestConfig<StartSignupAuthSignupEmailStartPostMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<StartSignupAuthSignupEmailStartPostMutationResponse, ResponseErrorConfig<StartSignupAuthSignupEmailStartPost409 | StartSignupAuthSignupEmailStartPost422 | StartSignupAuthSignupEmailStartPost429>, StartSignupAuthSignupEmailStartPostMutationRequest>({ method : "POST", url : getStartSignupAuthSignupEmailStartPostUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}